<template>
  <div class="container container-vende-tu-auto">
    <div class="row justify-content-center">
      <div class="img-hdr col-lg-12 col-md-12 col-sm-12 justify-content-sm-center"
        style="overflow:hidden; margin: 0; padding:0;">
        <img class="step-desktop" src="../assets/imgs/desktop/vende_tu_auto_paso1_web.png" alt="AUTOCOM" />
        <img class="step-tablet" src="../assets/imgs/tablet/vende_tu_auto_paso1_tablet.png" alt="AUTOCOM" />
        <img class="step-mobile" src="../assets/imgs/mobile/vende_tu_auto_paso1_mobile.png" alt="AUTOCOM" />
      </div>
      <div class="container container-info ">
        <div class="container-vende-view">
          <div class="content-va">
            <div class="text-center">

              <h1 class="bienvenida text-start mb-4">Bienvenido a <span>Vende tu auto</span>, la forma segura de vender
                tu auto por internet.</h1>
              <p class="instruccion text-start mb-3">Comienza por seleccionar la marca de tu vehículo, si no aparece en
                el listado, puedes escribir en el campo correspondiente. Recuerda que debes llenar los campos para poder
                continuar.</p>
              <p class="instruccion mb-5">Si ya cuentas con una oferta y quieres agendar o modificar la inspección <span
                  class="enlace" @click.prevent="openModalInspeccion()">haz clic aquí</span></p>
              <div class="row">
                <div class="col-md-6 col-sm-12 ">
                  <div>
                    <h5 class="texto-vehiculo">*Marca</h5>
                    <input v-if="this.viewMarca == false" required v-model="marcaSelect" type="text" class="-input 1"
                      @keyup="buscarMarca()" placeholder="Escribe o selecciona la marca de tu vehículo" />
                    <input v-if="this.viewMarca == true" required v-model="marcaSelect" type="text" class="-input 2"
                      @keyup="buscarMarca()" placeholder="Escribe o selecciona la marca de tu vehículo" />
                  </div>
                  <div class="row col-md-12 wrpr-destacadas" v-if="this.marcaActive == true && this.marcaSelect ==''">
                    <p class="destacadas">Marcas destacadas</p>
                  </div>
                  <div class="row row-cols-4" v-if="this.marcaActive == true && this.marcaSelect == ''">
                    <div style="margin-left: -5px" class="col" v-for="imgmarca in imagenMarcas" :key="imgmarca.idbrand">
                      <button class="btn-imgn" @click.prevent="models(imgmarca.name, imgmarca.idbrand)"><img
                          :src=imgmarca.imagen class="img-list" alt="" /></button>
                    </div>
                  </div>
                  <div class="row row-cols-4" v-if="this.marcaActive == true && this.marcaSelect !== ''">
                    <div style="margin-left: -5px" class="col" v-for="imagen in imagenes" :key="imagen.idbrand"> <button
                        class="btn-imgn" @click.prevent="models(imagen.name, imagen.idbrand)"><img :src=imagen.imagen
                          class="img-list" alt="" /></button></div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12  modelo">
                  <div v-if="this.modeloVista == true ">
                    <h5 class="texto-vehiculo">*Modelo</h5>
                    <input v-if="this.modeloView == false & this.active == true" required v-model="modeloSelect"
                      type="text" class="-input" @keyup="buscarModelo()"
                      placeholder="Escribe o selecciona el modelo de tu vehículo" />
                    <input v-if="this.modeloView == true  & this.active == true" required v-model="modeloSelect"
                      type="text" class="-input" @keyup="buscarModelo()"
                      placeholder="Escribe o selecciona el modelo de tu vehículo" />
                    <input v-if="this.noOfertam == true  & this.active == false" required v-model="modeloSelect"
                      type="text" class="-input" placeholder="Escribe el modelo de tu vehículo" />
                  </div>
                  <div v-if="this.modeloVista == false ">
                    <h5 class="texto-vehiculo">*Modelo</h5>
                    <input disabled type="text" class="-input"
                      placeholder="Escribe o selecciona el modelo de tu vehículo" />
                  </div>
                  <div style="margin-top: 15px; margin-left: -13px;">
                    <div class="row "
                      v-if="this.modeloActive == true && this.modeloSelect !== '' && this.marcaSelect !== ''"
                      style="margin-left: 0px;">
                      <div class="" v-for="model in modelos" :key="model.idmodel"> <button class="btn-imgnm"
                          @click.prevent="years(model.name, model.idmodel)">{{ model.name }}</button></div>
                    </div>
                    <div class=" "
                      v-if="this.modeloActive == true && this.modeloSelect == '' && this.marcaSelect !== ''"
                      style="margin-top: -10px; margin-left: 10px;">
                      <div style="float:left;" v-for="tmodel in topmodels" :key="tmodel.idmodel">
                        <button style="margin: 4px;" class="btn-imgnm"
                          @click.prevent="years(tmodel.name, tmodel.idmodel)">{{ tmodel.name }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 anio">
                  <div v-if="this.anioVista == true" style="margin-top: 20px">
                    <h5 class="texto-vehiculo-v">*Año</h5>
                    <input v-if="this.viewAnio == false & this.active == true" required v-model="aniosSelect"
                      type="text" class="-input" @keyup="buscarAnio()"
                      placeholder="Escribe o selecciona el año de tu vehículo" maxlength="4"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      pattern="[0-9]+" />
                    <input v-if="this.viewAnio == true & this.active == true" required v-model="aniosSelect" type="text"
                      class="-input" @keyup="buscarAnio()" placeholder="Escribe o selecciona el año de tu vehículo"
                      maxlength="4"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      pattern="[0-9]+" />
                    <input v-if="this.noOfertaa == true & this.active == false" required v-model="aniosSelect"
                      type="text" class="-input" placeholder="Escribe o selecciona el año de tu vehículo" maxlength="4"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      pattern="[0-9]+" />
                  </div>
                  <div class="margin-vehiculo" v-if="this.anioActive == true && this.aniosSelect !== ''"
                    style="margin-top: 0px; margin-left: 0px;">
                    <div class="row row-cols-4 mb-2">
                      <div class="col" v-for="anio in anios" :key="anio.idyear"> <button class="btn-imgna"
                          @click.prevent="versions(anio.name, anio.idyear)">{{ anio.name }}</button></div>
                    </div>
                  </div>
                  <div class="margin-vehiculo" v-if="this.anioActive == true && this.aniosSelect == ''"
                    style="margin-top: 0px; margin-left: 0px;">
                    <div class="row row-cols-4 mb-2">
                      <div class="col" v-for="tanio in topanios" :key="tanio.idyear"> <button class="btn-imgna"
                          @click.prevent="versions(tanio.name, tanio.idyear)">{{ tanio.name }}</button></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 version">
                  <div v-if="this.versionVista == true" style="margin-top: 20px">
                    <img src="../assets/imgs/ico-tooltip.svg" class="imgToolTip-v" @click="openTooltip" alt="" />
                    <div class="descripcion-tooltip d-none">
                      <p class="text-left p-tooltip"> Puedes encontrar ese dato en la factura, la póliza de seguro o el
                        manual de la unidad. </p>
                    </div>
                    <h5 class="texto-vehiculo-v">*Versión</h5>
                    <input v-if="this.viewVersion == false & this.active == true" required v-model="versionSelect"
                      type="text" class="-input" @keyup="buscarVersion()"
                      placeholder="Escribe o selecciona la versión de tu vehículo" />
                    <input v-if="this.viewVersion == true & this.active == true" required v-model="versionSelect"
                      type="text" class="-input" @keyup="buscarVersion()"
                      placeholder="Escribe o selecciona la versión de tu vehículo" />
                    <input v-if="this.noOfertav == true & this.active == false" required v-model="versionSelect"
                      type="text" class="-input" placeholder="Escribe o selecciona la versión de tu vehículo" />
                  </div>
                  <div class="margin-vehiculo" style="margin-top: 5px">
                    <div class="row row-cols-2 mb-2" v-if="this.versionActive == true && this.versionSelect !== ''">
                      <div class="col" v-for="version in versiones" :key="version.idversion"> <button class="btn-imgnv"
                          @click.prevent="colors(version.name, version.idtrim, version.vehicleid)">{{ version.name }}</button></div>
                    </div>
                    <div class="row row-cols-2 mb-2" v-if="this.versionActive == true && this.versionSelect == ''">
                      <div class="col" v-for="tversion in topversiones" :key="tversion.idversion"> <button
                          class="btn-imgnv"
                          @click.prevent="colors(tversion.name, tversion.idtrim, tversion.vehicleid)">{{ tversion.name }}</button></div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="margin-vehiculo" v-if="this.colorVista == true">
                    <h5 class="texto-vehiculo-v2">*Color</h5>
                    <input v-if="this.noOfertaColor == false" required v-model="colorSelect" type="text"
                      :class="[colorSelect ? colorSelect : '']" @keyup="buscarColor()"
                      placeholder="Selecciona el color de tu vehículo" />
                    <input v-if="this.noOfertaColor == true" required v-model="colorSelect" type="text"
                      :class="[colorSelect ? colorSelect : '']" placeholder="Selecciona el color de tu vehículo" />
                  </div>
                  <div class="col-md-12" style="margin-left: -10px;">
                    <div class="row row-cols-5 mt-2 mb-2" v-if="this.colorActive == true && this.colorSelect == ''">
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color1()"><img
                            src="../assets/colors/color_blanco.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Blanco</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color2()"><img
                            src="../assets/colors/color_plata.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Plata</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color3()"><img
                            src="../assets/colors/color_gris.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Gris</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color4()"><img
                            src="../assets/colors/color_negro.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Negro</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color5()"><img
                            src="../assets/colors/color_cafe-1.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Café</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color6()"><img
                            src="../assets/colors/color_rojo.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Rojo</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color7()"><img
                            src="../assets/colors/color_anaranjado.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Naranja</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color8()"><img
                            src="../assets/colors/color_amarillo.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Amarillo</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color9()"><img
                            src="../assets/colors/color_cafe.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Verde</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color10()"><img
                            src="../assets/colors/color_azul.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 0px">Azul</span> </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="margin-vehiculo" v-if="this.kmsVista == true">
                    <h5 class="texto-vehiculo-v2">*Kilometraje</h5>
                    <input type="text" @keyup="formatKms()" v-model="mileage" class="-input"
                      placeholder="Escribe el kilometraje de tu vehículo" required>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="margin-vehiculo" v-if="this.mileage !== '' && this.kmsVista == true">
                    <h5 class="texto-vehiculo-v2">*Precio esperado (opcional)</h5>
                    <input type="text" @keyup="formatPrice()" v-model="precio" class="-input"
                      placeholder="Escribe el precio esperado por tu vehículo" required>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="margin-vehiculo-2" v-if="this.mileage !== '' && this.kmsVista == true">
                    <h5 class="texto-vehiculo-v2">¿Estás siendo atendido por un asesor?</h5>
                    <label class="label-radio">
                      <input class="input-radio" v-model="seguimiento" type="radio" value="asesor" />Si
                    </label>
                    <label class="label-radio">
                      <input class="input-radio" v-model="seguimiento" type="radio" value="creatio" />No
                    </label>
                  </div>
                </div>
              </div>
              <div class="row justify-content-center mt-3 pedrictivo-dt" v-if="this.noOferta == true">
                <div>
                  <b-alert show variant="secondary">Puedes continuar y dejarnos tus datos para que un asesor se ponga en
                    contacto contigo.</b-alert>
                </div>
              </div>
              <div class="col-md-12 text-center desktop controls">
                <button class="-btn-continue" disabled v-if="!formBool">SIGUIENTE</button>
                <button class="-btn-continuar" @click.prevent="continuar()" v-else>SIGUIENTE</button>
              </div>
              <div class="col-sm-12 tablet">
                <button class="-btn-continue" disabled v-if="!formBool">SIGUIENTE</button>
                <button class="-btn-continuar" @click.prevent="continuar()" v-else>SIGUIENTE</button>
              </div>
              <div class="row row-cols-1 margin-info pedrictivo-mobile">
                <div class="col">
                  <div>
                    <h5 class="texto-vehiculo">*Marca</h5>
                    <input required v-model="marcaSelect" type="text" class="-input" @keyup="buscarMarca()"
                      @change="continuarSolicitud()" placeholder="Selecciona o busca la marca de tu vehículo" />
                  </div>
                  <div class="marcas">
                    <div class="row row-cols-3 mb-2" v-if="this.marcaActive == true && this.marcaSelect ==''">
                      <div class="col" v-for="imgmarca in imagenMarcas" :key="imgmarca.idbrand"> <button
                          class="btn-imgn" @click.prevent="models(imgmarca.name)"><img :src=imgmarca.imagen
                            class="img-list" alt="" /></button></div>
                    </div>
                    <div class="row row-cols-3 mb-2 marca" v-if="this.marcaActive == true && this.marcaSelect !==''">
                      <div class="col" v-for="imagen in imagenes" :key="imagen.idbrand"> <button class="btn-imgn"
                          @click.prevent="models(imagen.name)"><img :src=imagen.imagen class="img-list"
                            alt="" /></button></div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="modelo" v-if="this.modeloVista == true && this.marcaSelect !== '' ">
                    <h5 class="texto-vehiculo">*Modelo</h5>
                    <input v-if="this.noOfertam == false" required v-model="modeloSelect" type="text" class="-input"
                      @keyup="buscarModelo()" placeholder="Selecciona o busca el modelo de tu vehículo" />
                    <input v-if="this.noOfertam == true" required v-model="modeloSelect" type="text" class="-input"
                      placeholder="Escribe el modelo de tu vehículo" />
                  </div>
                  <div class="margin-vehiculo modelos">
                    <div class="row row-cols-3 mb-2"
                      v-if="this.modeloActive == true && this.modeloSelect !== '' && this.marcaSelect !==''"
                      style="margin-top: -20px; margin-left: -10px;">
                      <div class="col" v-for="model in modelos" :key="model.idmodel"> <button class="btn-imgnm"
                          @click.prevent="years(model.name)">{{model.name}}</button></div>
                    </div>
                    <div class="row row-cols-3 mb-2"
                      v-if="this.modeloActive == true && this.modeloSelect == '' && this.marcaSelect !==''"
                      style="margin-top: -20px; margin-left: -15px;">
                      <div class="col" v-for="tmodel in topmodels" :key="tmodel.idmodel"> <button class="btn-imgnm"
                          @click.prevent="years(tmodel.name)">{{tmodel.name}}</button></div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="margin-vehiculo-anio" v-if="this.anioVista == true" style="margin-top: 0px">
                    <h5 class="texto-vehiculo">*Año</h5>
                    <input v-if="this.noOfertaa == false" required v-model="aniosSelect" type="text" class="-input"
                      @keyup="buscarAnio()" placeholder="Selecciona o busca el año de tu vehículo" maxlength="4"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      pattern="[0-9]+" />
                    <input v-if="this.noOfertaa == true" required v-model="aniosSelect" type="text" class="-input"
                      placeholder="Escribe el año de tu vehículo" maxlength="4"
                      onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                      pattern="[0-9]+" />
                  </div>
                  <div class="margin-vehiculo" v-if="this.anioActive == true && this.aniosSelect !== ''"
                    style="margin-top: 0px; margin-left: 0px;">
                    <div class="row row-cols-4 mb-2">
                      <div class="col" v-for="anio in anios" :key="anio.idyear"> <button class="btn-imgna"
                          @click.prevent="versions(anio.name)">{{anio.name}}</button></div>
                    </div>
                  </div>
                  <div class="margin-vehiculo" v-if="this.anioActive == true && this.aniosSelect == ''"
                    style="margin-top: 0px; margin-left: 0px;">
                    <div class="row row-cols-4 mb-2">
                      <div class="col" v-for="tanio in topanios" :key="tanio.idyear"> <button class="btn-imgna"
                          @click.prevent="versions(tanio.name)">{{tanio.name}}</button></div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="version" v-if="this.versionVista == true">
                    <img src="../assets/imgs/ico-tooltip.svg" class="imgToolTip-v" @click="openTooltipMobile" alt="" />
                    <div class="descripcion-tooltip-mobile d-none">
                      <p class="text-left p-tooltip"> Puedes encontrar ese dato en la factura, la póliza de seguro o el
                        manual de la unidad. </p>
                    </div>
                    <h5 class="texto-vehiculo">*Versión</h5>
                    <input v-if="this.noOfertav == false" required v-model="versionSelect" type="text" class="-input"
                      @keyup="buscarVersion()" placeholder="Selecciona o busca la versión de tu vehículo" />
                    <input v-if="this.noOfertav == true" required v-model="versionSelect" type="text" class="-input"
                      placeholder="Escribe la versión de tu vehículo" />
                  </div>
                  <div class="margin-vehiculo" style="margin-left: 0px; margin-top: 5px">
                    <div class="row row-cols-1 mb-2" v-if="this.versionActive == true && this.versionSelect !== ''">
                      <div class="col" v-for="version in versiones" :key="version.idversion"> <button class="btn-imgnv"
                          @click.prevent="colors(version.name)">{{version.name}}</button></div>
                    </div>
                    <div class="row row-cols-1 mb-2" v-if="this.versionActive == true && this.versionSelect == ''">
                      <div class="col" v-for="tversion in topversiones" :key="tversion.idversion"> <button
                          class="btn-imgnv" @click.prevent="colors(tversion.name)">{{tversion.name}}</button></div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="margin-vehiculo" v-if="this.colorVista == true">
                    <h5 class="texto-vehiculo">*Color</h5>
                    <input v-if="this.noOfertaColor == false" required v-model="colorSelect" type="text" class="-input"
                      @keyup="buscarColor()" placeholder="Selecciona o escribe el color de tu vehículo" />
                    <input v-if="this.noOfertaColor == true" required v-model="colorSelect" type="text" class="-input"
                      placeholder="Escribe el color de tu vehículo" />
                  </div>
                  <div class="col-sm-6" style="margin-top: 0px; margin-left: -10px;">
                    <div class="row row-cols-5 mt-2 mb-2" v-if="this.colorActive == true && this.colorSelect == ''">
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color1()"><img
                            src="../assets/colors/color_blanco.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 10px">Blanco</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color2()"><img
                            src="../assets/colors/color_plata.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 15px">Plata</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color3()"><img
                            src="../assets/colors/color_gris.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 16px">Gris</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color4()"><img
                            src="../assets/colors/color_negro.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 10px">Negro</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color5()"><img
                            src="../assets/colors/color_cafe-1.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 15px">Café</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color6()"><img
                            src="../assets/colors/color_rojo.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 15px">Rojo</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color7()"><img
                            src="../assets/colors/color_anaranjado.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 7px">Naranja</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color8()"><img
                            src="../assets/colors/color_amarillo.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 6px">Amarillo</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color9()"><img
                            src="../assets/colors/color_cafe.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 12px">Verde</span> </div>
                      <div class="col txt-color text-center"><button class="btn-imgn" @click.prevent="color10()"><img
                            src="../assets/colors/color_azul.svg" class="img-listImg" alt="" /></button> <span
                          style="margin-left: 15px">Azul</span> </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="margin-vehiculo" v-if="this.kmsVista == true">
                    <h5 class="texto-vehiculo">*Kilometraje</h5>
                    <input type="text" @keyup="formatKms()" v-model="mileage" class="-input"
                      placeholder="Escribe el kilometraje de tu vehículo" required>
                  </div>
                </div>
                <div class="col">
                  <div class="margin-vehiculo" v-if="this.mileage !== '' && this.kmsVista == true">
                    <h5 class="texto-vehiculo">*Precio esperado (opcional)</h5>
                    <input type="text" @keyup="formatPrice()" v-model="precio" class="-input"
                      placeholder="Escribe el precio esperado por tu vehículo" required>
                  </div>
                </div>
                <div class="row justify-content-center mt-3 pedrictivo-mobile" v-if="this.noOferta == true">
                  <div class="" style="margin-left: 15px;">
                    <b-alert show variant="secondary">Puedes continuar y dejarnos tus datos para que un asesor se ponga
                      en contacto contigo.</b-alert>
                  </div>
                </div>
                <div class="col-12 mobile">
                  <button class="btn-continue" disabled v-if="!formBool">SIGUIENTE</button>
                  <button class="btn-continuar" @click.prevent="continuar()" v-else>SIGUIENTE</button>
                </div>
              </div>
              <p class="texto-oferta mt-2">
                Conoce los documentos que necesitas para vender tu auto, <span class="enlace"
                  @click="documentacion()">haz clic aquí</span>
              </p>

              <b-modal v-model="modalOferta" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="justify-content-md-center">
                  <div class="text-center modal-banner">
                    UNIDAD NO ENCONTRADA
                  </div>
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">No se encontraron resultados que coincidan con los datos <br> del
                      vehículo</div>
                    <div class="lamentamos mt-3">
                      Puedes continuar y dejarnos tus datos para que un asesor se <br> ponga en contacto contigo.
                    </div>
                  </div>
                  <div class="text-center mt-4 mb-4">
                    <div>
                      <button class="" @click.prevent="aceptarModal()">
                        CONTINUAR
                      </button>
                    </div>
                    <div>
                      <button class="btn-resend-modal button-secondary" @click.prevent="salirSolicitud()">
                        SALIR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalOfertaModelo" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="justify-content-md-center">
                  <div class="text-center modal-banner">
                    UNIDAD NO ENCONTRADA
                  </div>
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">No se encontraron resultados que coincidan con los datos <br> del
                      vehículo</div>
                    <div class="lamentamos mt-3">
                      Puedes continuar y dejarnos tus datos para que un asesor se <br> ponga en contacto contigo.
                    </div>
                  </div>
                  <div class="text-center mt-4 mb-4">
                    <div>
                      <button class="" @click.prevent="aceptarModel()">
                        CONTINUAR
                      </button>
                    </div>
                    <div>
                      <button class="btn-resend-modal button-secondary" @click.prevent="salirSolicitud()">
                        SALIR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalOfertaAnio" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="justify-content-md-center">
                  <div class="text-center modal-banner">
                    UNIDAD NO ENCONTRADA
                  </div>
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">No se encontraron resultados que coincidan con los datos <br> del
                      vehículo</div>
                    <div class="lamentamos mt-3">
                      Puedes continuar y dejarnos tus datos para que un asesor se <br> ponga en contacto contigo.
                    </div>
                  </div>
                  <div class="text-center mt-4 mb-4">
                    <div>
                      <button class="" @click.prevent="aceptarAnio()">
                        CONTINUAR
                      </button>
                    </div>
                    <div>
                      <button class="btn-resend-modal button-secondary" @click.prevent="salirSolicitud()">
                        SALIR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalOfertaVersion" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="justify-content-md-center">
                  <div class="text-center modal-banner">
                    UNIDAD NO ENCONTRADA
                  </div>
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">No se encontraron resultados que coincidan con los datos <br> del
                      vehículo</div>
                    <div class="lamentamos mt-3">
                      Puedes continuar y dejarnos tus datos para que un asesor se <br> ponga en contacto contigo.
                    </div>
                  </div>
                  <div class="text-center mt-4 mb-4">
                    <div>
                      <button class="" @click.prevent="aceptarVersion()">
                        CONTINUAR
                      </button>
                    </div>
                    <div>
                      <button class="btn-resend-modal button-secondary" @click.prevent="salirSolicitud()">
                        SALIR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalModificar" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="content-modal justify-content-md-center">
                  <div class="col-sm-12 text-center">

                    <img class="ico-inspeccion" src="../assets/imgs/ico-inspeccion.svg" alt="AUTOCOM" />
                    <div class="modal-title mt-0">Agendar inspección</div>
                    <div class="lament mt-4">
                      Escribe el No. de Oferta o teléfono registrado en la solicitud de oferta
                    </div>
                    <div v-if="this.telefono.length == 0" class=" mt-4">
                      <h5 class="label-folio">No. de Oferta</h5>
                      <input type="text" v-model="folioVa" class="input-modal" placeholder="Escribe el No. de Oferta">
                    </div>
                    <div v-if="this.telefono.length > 0" class=" mt-4">
                      <h5 class="label-folio">No. de Oferta</h5>
                      <input type="text" v-model="folioVa" class="input-modal"
                        placeholder="Escribe el No. de Folio de tu oferta" disabled>
                    </div>
                    <div v-if="this.folioVa.length == 0" class=" mt-4">
                      <h5 class="label-telefono">Teléfono</h5>
                      <input type="text" v-model="telefono" class="input-modal"
                        placeholder="Escribe el teléfono registrado en la solicitud" maxlength="10"
                        onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                        pattern="[0-9]+" />
                    </div>
                    <div v-if="this.folioVa.length > 0" class=" mt-4">
                      <h5 class="label-telefono">Teléfono</h5>
                      <input type="text" v-model="telefono" class="input-modal"
                        placeholder="Escribe el teléfono registrado en la solicitud" disabled>
                    </div>
                  </div>
                  <div class="text-center mt-4">
                    <div class="controls">
                      <button class="" @click.prevent="validaFolio()">
                        BUSCAR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalnoEncontrado" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="content-modal justify-content-md-center">
                  <div class="col-sm-12 text-center">

                    <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />
                    <div class="modal-title mt-0">No. de Oferta no encontrada</div>
                    <div class="lament mt-4">
                      El no. de Oferta no se encuentra<br>en nuestro sistema, intenta con una oferta válida
                    </div>
                    <div class=" mt-4">
                      <h5 class="label-folio-2">No. de Oferta</h5>
                      <input type="text" v-model="folioVa" class="input-modal" placeholder="Escribe el No. de Oferta">
                    </div>
                  </div>
                  <div class="controls row">

                    <div class="col-md-6 col-sm-12  order-md-2 right">
                      <button class="-btn-continuar continue" @click.prevent="validaNuevoFolio()">
                        BUSCAR
                      </button>
                    </div>
                    <div class="col-md-6 col-sm-12  order-md-1 left">
                      <button class="button-secondary  -btn-continuar continue" @click.prevent="cerrarModal()">
                        CERRAR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalErrorConexion" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="content-modal justify-content-md-center">
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">ERROR EN NUESTRO SISTEMA</div>
                    <img class="ico-inspeccion" src="../assets/imgs/error_varios_icon.svg" alt="AUTOCOM" />
                    <div class="lamentamos mt-3">
                      Nuestro servicio está presentando errores, por el<br> momento no es posible realizar la operación,
                      inténtalo <br> más tarde. <br> <span class="msnError">{{this.mensajeError}}</span>
                    </div>
                  </div>
                  <div class="text-center mt-4">
                    <div class="controls">
                      <button class="" @click.prevent="cerrarModal()">
                        CERRAR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalenSeguimiento" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="content-modal justify-content-md-center">
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">OFERTA EN SEGUIMIENTO</div>
                    <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />
                    <div class="lamentamos mt-3">
                      Un asesor ya ha tomado la Oferta para darle seguimiento, <br> en breve se contactará contigo.
                    </div>
                  </div>
                  <div class="text-center mt-4">
                    <div class="controls">
                      <button class="" @click.prevent="cerrarModal()">
                        CERRAR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

              <b-modal v-model="modalnoValido" size="lg" style="width: 100%" hide-header hide-footer>
                <b-row cols="1" class="content-modal justify-content-md-center">
                  <div class="col-sm-12 text-center">
                    <div class="modal-title mt-5">OFERTA NO VALIDA</div>
                    <img class="ico-inspeccion" src="../assets/imgs/mdi_alert-outline.svg" alt="AUTOCOM" />
                    <div class="lamentamos mt-3">
                      La oferta ingesada ya no es vigente <br> recuerda que las ofertas tienen una validez de 8 días
                    </div>
                  </div>
                  <div class="text-center mt-4">
                    <div class="controls">
                      <button class="" @click.prevent="cerrarModal()">
                        CERRAR
                      </button>
                    </div>
                  </div>
                </b-row>
              </b-modal>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import axios from "axios";

  export default {
    name: "Vehiculo",

    components: {

    },


    data() {
      return {

      // server: 'https://srv-autocheck.autocomseminuevos.com/api',
      

      

      // serverAnalizador: 'https://qa-api-analizador.autocom.mx/api',
      //server: 'https://dev-srv-valoraciones.autocom.mx/api',


      /*serverAnalizador: 'https://qa-api-analizador.autocom.mx/api',
      serverAutoCheck: 'https://qa-api-autocheck.autocom.mx/api',
      creatioService: 'https://qa-creatioservice.autocom.mx/api',
      serverComunicaciones: 'https://qa-comunicaciones.autocom.mx/api',*/

      //https://qa-api-autocheck.autocom.mx/api

      serverAnalizador: process.env.VUE_APP_SERVER_ANALIZADOR,
      serverAutoCheck: process.env.VUE_APP_SERVER_AUTOCHECK,
      creatioService: process.env.VUE_APP_CREATIO_SERVICE,
      serverComunicaciones: process.env.VUE_APP_SERVER_COMUNICACIONES,


        active: true,

        folioVa: '',
        telefono: '',

        marcaActive: true,
        modeloActive: false,
        anioActive: false,
        versionActive: false,
        colorActive: false,
        kmsActive: false,

        marcaVista: true,
        marca: "",
        idmarca: "",
        idmarcaM: "",
        nombreMarca: "",
        marcas: [],
        marcaSelect: "",

        modeloVista: false,
        modelo: "",
        idmodelo: "",
        nombreModelo: "",
        topmodels: [],
        modelos: [],
        modeloSelect: "",

        anioVista: false,
        anio: "",
        idanio: "",
        nombreAnio: "",
        topanios: [],
        anios: [],
        aniosSelect: "",

        versionVista: false,
        version: "",
        idversion: "",
        nombreVersion: "",
        topversiones: [],
        versiones: [],
        versionSelect: "",

        mileage: "",
        formBool: false,

        colorVista: false,
        kmsVista: false,
        precioVista: false,


        colorSelect: "",
        precio:"",
        imagenMarcas: "",
        imagenes: [],

        modalOferta: false,
        modalOfertaModelo: false,
        modalOfertaAnio: false,
        modalOfertaVersion: false,
        modalModificar:false,
        modalnoEncontrado: false,
        modalenSeguimiento: false,
        modalErrorConexion: false,
        modalnoValido: false,

        mensajeError: "",

        bandera: "",
        banderam: "",
        banderaa: "",
        banderav: "",

        modeloView: false,
        viewMarca: false,
        viewAnio: false,
        viewVersion: false,

        noOferta: false,
        noOfertam: false,
        noOfertaa: false,
        noOfertav: false,
        noOfertaColor: false,

        seguimiento: 'creatio',
        idVehicle:""
      };
    },

    methods: {

      continuar(){
        this.siguiente();
      },

      salirSolicitud(){
        this.modalOferta = false;
        this.modalOfertaModelo = false;
        this.modalOfertaAnio = false;
        this.modalOfertaVersion = false;

        this.marcaSelect='';
        this.modeloSelect='';

        this.buscarMarca();

      },

      openTooltip(){
        const tooltip = document.querySelector('.descripcion-tooltip')
        if(tooltip.classList.contains('d-none')){
          tooltip.classList.remove('d-none');
        }else{
          tooltip.classList.add('d-none');
        }
      },

      openTooltipMobile(){
        const tooltip = document.querySelector('.descripcion-tooltip-mobile')
        tooltip.classList.toggle('d-none')
      },

      cargarToken() {

        //analyzer22 prod
        //analyzer24 dev

        //let user = { usuario: "autocom_seminuevos", password: "invarart2022Semi" };

        //let user = { usuario: "autocom_price", clave: "analyzer24", op: "token" }; //QA
        //let user = { usuario: "autocom_price", clave: "analyzer22", op: "token" }; // prod

        let user = { usuario: "autocom_price", clave: process.env.VUE_APP_PASSWORD, op: "token" }; //QA
        //let user = { usuario: "autocom_price", clave: "analyzer22", op: "token" }; // prod

        axios
          .post(this.serverAnalizador + "/auth", user)
          .then((response) => {
            //console.log(response.data.token);

            //sessionStorage.setItem("tokenIntelimotor", response.data.token);
            sessionStorage.setItem("tokenIntelimotor", response.data.token);
            this.topBrands();
          })
          .catch((error) => {
            this.modalErrorConexion = true;
            this.mensajeError = 'EACT';
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
          });
      },

    tokenComunicaciones(){
        let user = {usuario: "Comunicaciones", password: "C0mun1c4c10n35"};
        axios.post(this.serverComunicaciones + "/auth", user)
        .then((response) => {
          //console.log("token stock-->", response.data.token);
          sessionStorage.setItem("tokenComunicacion", response.data.token);
        }).catch((error) => {
           this.mensajeError1 = 'ECOTK';
           this.modalErrorConexion = true;
           console.log('Error en el servicio de comunicaciones ...',error.message)
        });
    },

  // Validaciones Marcas
      topBrands() {

        let body = { sp: "brands", op: "brands_top", fuente:"BI", url: "https://qa-resource-analizador.autocom.mx/" }

        axios
          .post(this.serverAnalizador + "/brands/top", body, {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            this.imagenMarcas = response.data.data[0];
            //console.log('Marcas -->', this.imagenMarcas);
          })
          .catch((error) => {
            this.modalErrorConexion = true;
            this.mensajeError = 'EACLM';
            this.snifferError(error.message,'valoraciones');
            console.log('Existe un error en valoraciones ...',error.message);
          });
      },
      openModalInspeccion(){
        this.modalModificar=true;
      },

      buscarMarca(){

         if (this.marcaSelect !== '') {

           let body = {
             sp: "brands",
             op: "brands_search",
             url: "https://qa-resource-analizador.autocom.mx/",
             idbrand: "",
             marca: this.marcaSelect
           };
           axios
             .post(
               this.serverAnalizador + "/brands/search",
               body,
               {
                 headers: {
                   Authorization:
                     "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                   "Content-Type": "application/json",
                 },
               }
             )
             .then((response) => {

               this.bandera = response.data.data[0].length;

               if (this.bandera === 0) {
                 this.marcaActive = false;
                 this.viewMarca = true;
                 this.modalOferta = true;
               } else {
                 this.marcaActive == true;
                 this.imagenes = response.data.data[0];
                this.modeloVista = false;
                this.modeloActive = false;
                this.anioActive = false;
                this.anioVista = false;
                this.versionActive = false;
                this.versionVista = false;
                this.colorActive = false;
                this.colorVista = false;
                this.kmsVista = false;
                this.precioVista = false;
              }

            }).catch((error) => {
              this.modalErrorConexion = true;
              this.mensajeError = 'EACBM';
              this.snifferError(error.message,'valoraciones');
              console.log('Existe un error en valoraciones ...',error.message);
            });
         } else {
            this.modeloSelect = "";
            this.aniosSelect = "";
            this.versionSelect = "";
            this.mileage = "";
            this.colorSelect = "";
            this.precio = "";
            this.marcaActive = true;
            this.modeloVista = false;
            this.modeloActive = false;
            this.anioActive = false;
            this.anioVista = false;
            this.versionActive = false;
            this.versionVista = false;
            this.colorActive = false;
            this.colorVista = false;
            this.kmsVista = false;
            this.precioVista = false;
         }
      },

      continuarSolicitud(){
        if (this.bandera === 0 && this.marcaSelect.length > 0) {
          this.modalOferta = true;
        } else if (this.marcaSelect == '') {
          console.log('Continuar Marca ...');
        }
      },

      resetMarca(){
        if (this.marcaSelect.length === 0) {
            this.viewMarca = false;
            this.modeloSelect = "";
            this.aniosSelect = "";
            this.versionSelect = "";
            this.mileage = "";
            this.colorSelect = "";
            this.precio = "";
            this.marcaActive = true;
            this.modeloVista = false;
            this.modeloActive = false;
            this.anioActive = false;
            this.anioVista = false;
            this.versionActive = false;
            this.versionVista = false;
            this.colorActive = false;
            this.colorVista = false;
            this.kmsVista = false;
            this.precioVista = false;
        }
      },

      aceptarModal(){
          this.noOferta = true;
          this.noOfertam = true;
          this.active = false;
          this.noOfertaa = true;
          this.noOfertav = true;
          this.noOfertaColor = true;
          this.modeloSelect = "";
          this.aniosSelect = "";
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive = false;
          this.modeloVista = true;
          this.modeloActive = false;
          this.anioActive = false;
          this.anioVista = true;
          this.versionActive = false;
          this.versionVista = true;
          this.colorActive = false;
          this.colorVista = true;
          this.kmsVista = true;
          this.precioVista = true;
          this.modalOferta = false;
      },

  // Modelos
      models(marca, id) {

        this.marcaSelect = marca;
        this.noOferta = false;
        this.active = true;
        this.noOfertam = false;
        this.modeloActive = false;
        this.marcaActive = false;
        this.modeloVista = true;
        this.idmarcaM=id;

        console.log("Marca "+id);

        //console.log('entrando modelos');
        this.topModel(this.marcaSelect, id)
      },

      topModel(marca, id) {
        //console.log('entrando modelos top ');
        let body = { sp: "models", op: "models_top", idbrand: id };
        //console.log(body);

        axios
          .post(
            this.serverAnalizador + "/models/top/",
            body,
            {
              headers: {
                Authorization:
                  "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.topmodels = response.data.data[0];
            this.idmarcaM = id;
            //console.log(this.topmodels);
            this.modeloActive = true;
          })
          .catch((error) => {
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
            //this.modalOferta = true;
            this.mensajeError = 'EACBMO';
            this.modalErrorConexion = true;
          });
      },

      buscarModelo() {

        if (this.modeloSelect !== '') {
          let body = {
            sp: "models",
            op: "models_search",
            idbrand: this.idmarcaM,
            idmodel: "",
            modelo: this.modeloSelect
          };
          axios
            .post(
              this.serverAnalizador + "/models/search",
              body,
              {
                headers: {
                  Authorization:
                    "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {

              this.banderam = response.data.data[0].length;

              if (this.banderam === 0) {
                this.modeloView = true;
                this.active = true;
                this.modeloActive = false;
                this.modalOfertaModelo = true;
              } else {
                this.modelos = response.data.data[0];
                this.noOferta = false;
                this.marcaActive == false;
                this.modeloVista = true;
                this.modeloActive = true;
                this.anioActive = false;
                this.anioVista = false;
                this.versionActive = false;
                this.versionVista = false;
                this.colorActive = false;
                this.colorVista = false;
                this.kmsVista = false;
                this.precioVista = false;
              }

            })
            .catch((error) => {
              this.modalErrorConexion = true;
              this.mensajeError = 'EACO1MO';
              this.snifferError(error.message, 'valoraciones');
              console.log('Existe un error en valoraciones ...', error.message);
            });
        } else {
          this.aniosSelect = "";
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive == false;
          this.modeloVista = true;
          this.modeloActive = true;
          this.anioActive = false;
          this.anioVista = false;
          this.versionActive = false;
          this.versionVista = false;
          this.colorActive = false;
          this.colorVista = false;
          this.kmsVista = false;
          this.precioVista = false;
        }
      },

      continuarModelo(){
        if (this.banderam === 0 && this.modeloSelect.length > 0) {
          this.modalOfertaModelo = true;
        } else if (this.modeloSelect == '') {
          console.log('Continuar Modelo ...');
        }
      },

      resetModelo(){

        if (this.modeloSelect.length === 0) {
            this.modeloView = false;
            this.noOfertam = false;
            this.noOfertaa = false;
            this.noOfertav = false;
            this.noOfertaColor = false;
            this.aniosSelect = "";
            this.versionSelect = "";
            this.mileage = "";
            this.colorSelect = "";
            this.precio = "";
            this.marcaActive == false
            this.modeloVista = true;
            this.modeloActive = false;
            this.anioActive = false;
            this.anioVista = false;
            this.versionActive = false;
            this.versionVista = false;
            this.colorActive = false;
            this.colorVista = false;
            this.kmsVista = false;
            this.precioVista = false;
            this.models(this.marcaSelect);
          }
      },

      aceptarModel(){
          this.noOferta = true;
          this.noOfertam = false;
          this.noOfertaa = true;
          this.noOfertav = true;
          this.noOfertaColor = true;
          this.aniosSelect = "";
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive == false
          this.modeloVista = true;
          this.modeloActive = false;
          this.anioActive = false;
          this.anioVista = true;
          this.versionActive = false;
          this.versionVista = true;
          this.colorActive = false;
          this.colorVista = true;
          this.kmsVista = true;
          this.precioVista = true;
          this.modalOfertaModelo = false;
      },

  // Años

      years(m, id) {
        this.modeloSelect = m;
        this.noOferta = false;
        this.active = true;
        this.noOfertaa = false;
        this.anioVista = true;
        this.anioActive = false;
        this.modeloActive = false;
        this.idmodeloM = id;
        this.topyears(this.modeloSelect);
      },

      topyears() {
        let body = {
          sp: "years",
          op: "years_top",
          idbrand: this.idmarcaM,
          idmodel: this.idmodeloM
        };

        axios
          .post(
            this.serverAnalizador + "/years/filter/",
            body,
            {
              headers: {
                Authorization:
                  "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            //console.log(response.data);
            this.fechasArreglo = Object.values(response.data.data[0]);
            this.topanios = this.fechasArreglo.slice(0, 12);

            this.anioActive = true;
          })
          .catch((error) => {
            //this.modalOferta = true;
            this.mensajeError = 'EACTY';
            this.modalErrorConexion = true;
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
          });
      },

      buscarAnio() {

        if (this.aniosSelect !== '') {

          let body = {
            sp: "years",
            op: "years_search",
            idbrand: this.idmarcaM,
            idmodel: this.idmodeloM,
            idyear: "",
            anio: this.aniosSelect
          };
          //console.log(body);
          axios
            .post(
              this.serverAnalizador + "/years/search",
              body,
              {
                headers: {
                  Authorization:
                    "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {

              this.banderaa = response.data.data[0].length;

              if (this.banderaa === 0) {
                this.viewAnio = true;
                this.active = true;
                this.anioActive = false;
                this.modalOfertaAnio = true;
              } else {
                this.anios = response.data.data[0];
                this.versionSelect = "";
                this.mileage = "";
                this.colorSelect = "";
                this.precio = "";
                this.noOferta = false;
                this.marcaActive == false;
                this.modeloVista = true;
                this.modeloActive = false;
                this.anioActive = true;
                this.anioVista = true;
                this.versionActive = false;
                this.versionVista = false;
                this.colorActive = false;
                this.colorVista = false;
                this.kmsVista = false;
                this.precioVista = false;
              }
            })
            .catch((error) => {
              //this.modalOferta = true;
              this.mensajeError = 'EACOA';
              this.modalErrorConexion = true;
              this.snifferError(error.message, 'valoraciones');
              console.log('Existe un error en valoraciones ...', error.message);
            });

        } else {
          this.aniosSelect = "";
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive = false;
          this.modeloVista = true;
          this.marcaActive == true;
          this.modeloActive = false;
          this.anioActive = true;
          this.anioVista = true;
          this.versionActive = false;
          this.versionVista = false;
          this.colorActive = false;
          this.colorVista = false;
          this.kmsVista = false;
          this.precioVista = false;
        }
      },

      continuarAnio(){
        if (this.banderaa === 0 && this.aniosSelect.length > 0) {
          this.modalOfertaAnio = true;
        } else if (this.aniosSelect == '') {
          console.log('Continuar Anio ...');
        }
      },

      resetAnio(){

        if (this.aniosSelect.length == 0) {
            this.viewAnio = false;
            this.noOfertaa = false;
            this.noOfertav = false;
            this.noOfertaColor = false;
            this.aniosSelect = "";
            this.versionSelect = "";
            this.mileage = "";
            this.colorSelect = "";
            this.precio = "";
            this.marcaActive == false
            this.modeloVista = true;
            this.modeloActive = false;
            this.anioActive = true;
            this.anioVista = true;
            this.versionActive = false;
            this.versionVista = false;
            this.colorActive = false;
            this.colorVista = false;
            this.kmsVista = false;
            this.precioVista = false;
        }
      },

      aceptarAnio(){
          this.noOferta = true;
          this.noOfertam = false;
          this.noOfertaa = false;
          this.noOfertav = true;
          this.noOfertaColor = true;
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive == false
          this.modeloVista = true;
          this.modeloActive = false;
          this.anioActive = false;
          this.anioVista = true;
          this.versionActive = false;
          this.versionVista = true;
          this.colorActive = false;
          this.colorVista = true;
          this.kmsVista = true;
          this.precioVista = true;
          this.modalOfertaAnio = false;
      },

  // Versiones
      versions(a, id) {
        this.aniosSelect = a;
        this.noOferta = false;
        this.active = true;
        this.noOfertav = false;
        this.anioActive = false;
        this.versionVista = false;
        this.versionActive = false;

        this.idanioM = id;
        this.topversion();

      },

      topversion() {
        let body = {
          sp: "trims",
          op: "trims_top",
          idbrand: this.idmarcaM,
          idmodel: this.idmodeloM,
          idyear: this.idanioM
        };

        //console.log(body);
        axios
          .post(
            this.serverAnalizador + "/trims/filter/",
            body,
            {
              headers: {
                Authorization:
                  "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {

            this.prueba = response.data.length;
            if (this.prueba === 0) {
              this.modalOfertaVersion = true;
            } else {
              this.versionArreglo = Object.values(response.data.data[0]);
              this.topversiones = this.versionArreglo.slice(0, 12);
              //console.log('Top -->',this.topversiones);
              this.versionVista = true;
              this.versionActive = true;
            }
          })
          .catch((error) => {
            //this.modalOferta = true;
            this.mensajeError = 'EACOV';
            this.modalErrorConexion = true;
            this.snifferError(error.message, 'valoraciones');
            console.log('Existe un error en valoraciones ...', error.message);
          });
      },

      buscarVersion() {

        if (this.versionSelect !== '') {

          let body = {
            sp: "trims",
            op: "trims_search",
            idbrand: this.idmarcaM,
            idmodel: this.idmodeloM,
            idyear: this.idanioM,
            idtrim: "",
            version: this.versionSelect
          };

          axios
            .post(
              this.serverAnalizador + "/trims/search",
              body,
              {
                headers: {
                  Authorization:
                    "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {

              this.banderav = response.data.data[0].length;

              if (this.banderav === 0) {
                this.viewVersion = true;
                this.active = true;
                this.versionActive = false;
                this.modalOfertaVersion = true;
              } else {
                this.versiones = response.data.data[0];
                console.log('versiones -->', response.data.data[0]);
                this.idversion = this.versiones[0].idtrim;
                this.nombreVersion = this.versiones[0].name;
                this.noOferta = false;
              }
            })
            .catch((error) => {
              //this.modalOferta = true;
              this.mensajeError = 'EACO1V';
              this.modalErrorConexion = true;
              this.snifferError(error.message, 'valoraciones');
              console.log('Existe un error en valoraciones ...', error.message);
            });

        } else {
          this.noOferta = false;
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive = false;
          this.modeloVista = true;
          this.marcaActive == true;
          this.modeloActive = false;
          this.anioActive = false;
          this.anioVista = true;
          this.versionActive = true;
          this.versionVista = true;
          this.colorActive = false;
          this.colorVista = false;
          this.kmsVista = false;
          this.precioVista = false;
        }
      },

      continuarVersion(){
        if (this.banderav === 0 && this.versionSelect.length > 0) {
          this.modalOfertaVersion = true;
        } else if (this.versionSelect == '') {
          console.log('Continuar Version ...');
        }
      },

      resetVersion(){

        if (this.versionSelect.length == 0) {
          this.viewVersion = false;
          this.noOfertav = false;
          this.noOfertaColor = false;
          this.versionSelect = "";
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive == false
          this.modeloVista = true;
          this.modeloActive = false;
          this.anioActive = false;
          this.anioVista = true;
          this.versionActive = true;
          this.versionVista = true;
          this.colorActive = false;
          this.colorVista = false;
          this.kmsVista = false;
          this.precioVista = false;
        }
      },

      aceptarVersion(){
          this.noOferta = true;
          this.noOfertam = false;
          this.noOfertaa = false;
          this.noOfertav = false;
          this.noOfertaColor = true;
          this.mileage = "";
          this.colorSelect = "";
          this.precio = "";
          this.marcaActive == false
          this.modeloVista = true;
          this.modeloActive = false;
          this.anioActive = false;
          this.anioVista = true;
          this.versionActive = false;
          this.versionVista = true;
          this.colorActive = false;
          this.colorVista = true;
          this.kmsVista = true;
          this.precioVista = true;
          this.modalOfertaVersion = false;
      },

  // Colores

      colors(v, id, vehicle) {
        this.noOferta = false;
        this.noOfertaColor = false;
        this.versionSelect = v;
        this.versionActive = false;
        this.colorVista = true;
        this.colorActive = true;

        this.idversionM = id;
        this.idVehicle=vehicle;
        //console.log('idversionM --->', this.idversionM);
      },

      color1(){
        this.colorSelect = "Blanco";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color2(){
        this.colorSelect = "Plata";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color3(){
        this.colorSelect = "Gris";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color4(){
        this.colorSelect = "Negro";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color5(){
        this.colorSelect = "Cafe";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color6(){
        this.colorSelect = "Rojo";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color7(){
        this.colorSelect = "Naranja";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color8(){
        this.colorSelect = "Amarillo";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color9(){
        this.colorSelect = "Verde";
        this.colorActive = false;
        this.kmsVista = true;
      },

      color10(){
        this.colorSelect = "Azul";
        this.colorActive = false;
        this.kmsVista = true;
      },


      buscarColor(){

        if ( this.colorSelect.length > 2 ) {
            this.kmsVista = true;
            this.noOferta = false;
        }  else {
          this.mileage = "";
          this.precio = "";
            this.marcaActive = false;
            this.modeloVista = true;
            this.marcaActive == true;
            this.modeloActive = false;
            this.anioActive = false;
            this.anioVista = true;
            this.versionActive = false;
            this.versionVista = true;
            this.colorActive = true;
            this.colorVista = true;
            this.kmsActive = false;
            this.kmsVista = false;
            this.precioVista = false;
          }
      },


      siguiente() {
          sessionStorage.setItem("idmarca", this.idmarcaM);
          sessionStorage.setItem("idmodelo", this.idmodeloM);
          sessionStorage.setItem("idanio", this.idanioM);
          sessionStorage.setItem("idversion", this.idversionM);
          sessionStorage.setItem("idvehicle", this.idVehicle);

          sessionStorage.setItem("marca", this.marcaSelect);
          sessionStorage.setItem("modelo", this.modeloSelect);
          sessionStorage.setItem("anio", this.aniosSelect);
          sessionStorage.setItem("version", this.versionSelect);
          sessionStorage.setItem("color", this.colorSelect);
          sessionStorage.setItem("kilometraje", this.mileage.replace(/,/g, ""));
          sessionStorage.setItem("precioSolicitado", (this.precio.replace(/,/g, "")).replace("$ ", ''));
          sessionStorage.setItem("noOferta", this.noOferta);
          sessionStorage.setItem("seguimiento", this.seguimiento);


        this.$router.push({ path: "/Vendedor" });
      },

      validaFolio() {

      let body = { folio: this.folioVa,
            telefono: this.telefono
            };

      axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          //console.log('response -->',response);

          if (response.data.status === 204) {

            this.modalModificar = false;
            this.modalnoValido = false;
            this.modalnoEncontrado = true;
            this.modalenSeguimiento = false;
            this.folioVa = '';
            this.telefono = '';

          } else if (response.data.data[0].para_reagendamiento === "No") {

            this.modalModificar = false;
            this.modalnoValido = false;
            this.modalnoEncontrado = false;
            this.modalenSeguimiento = true;
            this.folioVa = '';
            this.telefono = '';

          } else {

            this.validaVigencia();

          }

        })
        .catch((error) => {
          this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.errorvaloracion = true;
          this.snifferError(error.message,'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);

          if (error.response.status === 400) {
            this.modalModificar = false;
            this.modalnoValido = false;
            this.modalnoEncontrado = true;
            this.modalenSeguimiento = false;
            this.folioVa = '';
            this.telefono = '';
          } else {
            this.mensajeError = 'EVAVF';
            this.modalErrorConexion = true;
          }


        });

      },

      validaNuevoFolio() {

      let body = { folio: this.folioVa,
            telefono: ''
            };

      axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          if (response.data.status === 204) {

          this.modalModificar = false;
          this.modalnoValido = false;
          this.modalnoEncontrado = true;
          this.modalenSeguimiento = false;
          this.folioVa = '';
          this.telefono = '';

          } else if (response.data.data[0].para_reagendamiento === "No") {

          this.modalModificar = false;
          this.modalnoValido = false;
          this.modalnoEncontrado = false;
          this.modalenSeguimiento = true;
          this.folioVa = '';
          this.telefono = '';

          } else {

          this.validaVigencia();

          }

        })
        .catch((error) => {
          this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.errorvaloracion = true;
          this.snifferError(error.message,'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);

          if (error.response.status === 400) {
            this.modalModificar = false;
            this.modalnoValido = false;
            this.modalnoEncontrado = true;
            this.modalenSeguimiento = false;
            this.folioVa = '';
            this.telefono = '';
          } else {
            this.mensajeError = 'EVAVF';
            this.modalErrorConexion = true;
          }
        });

      },

      validaVigencia() {

      let body = { folio: this.folioVa,
            telefono: this.telefono
            };

      axios.post(
        this.serverAutoCheck + "/calendario/valoracion_agendamiento",
          body,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {

          const date = new Date();
          // const output = String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear();
          const output = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
            const dia = new Date(output).getTime();
            const diac = Math.round(dia/(1000*60*60*24));

          this.diaActual = output;
          this.diaVigencia = response.data.data[0].vigencia_oferta.substring(0,2);
          this.mesVigencia = response.data.data[0].vigencia_oferta.substring(3,5);
          this.anioVigencia = response.data.data[0].vigencia_oferta.substring(6,10);
          this.fechaVigencia = this.anioVigencia+'-'+this.mesVigencia+'-'+this.diaVigencia;
          const dia2 = new Date(this.fechaVigencia).getTime();
          const diac2 = Math.round(dia2/(1000*60*60*24));

          //console.log('Días -->',diac+' - '+diac2);

          if (diac > diac2) {

              this.modalModificar = false;
              this.modalnoValido = true;
              this.modalnoEncontrado = false;
              this.modalenSeguimiento = false;
              this.folioVa = '';
              this.telefono = '';

            } else {

              //this.tokenCreatio();
              this.validaInfoFolio();

            }
        })
        .catch((error) => {
          this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
          this.errorvaloracion = true;
          this.mensajeError = 'EVAVVF';
          this.modalErrorConexion = true;
          this.snifferError(error.message,'valoraciones');
          console.log('Existe un error en valoraciones ...', error.message);
        });

      },

      /*tokenCreatio(){
          let user = {usuario: "CreatioService", password: "Cr34t1053rv1c3"};
          axios.post(this.creatioService + "/auth", user)
          .then((response) => {
            //console.log("token stock-->", response.data.token);
            sessionStorage.setItem("tokenCreatio", response.data.token);
          }).catch(error=>{
            //this.modalErrorConexion = true;
            // this.mensajeError = 'ECTKN';
            // this.modalErrorConexion = true;
              this.snifferError(error.message,'Creatio');
              console.log('Existe un error en Creatio ...',error.message);
          });
      },*/

      /*consultaCreatio(){

        console.log('Consulta Creatio Oferta');

        this.idAutocheck = sessionStorage.getItem("idvaloration");

        axios.get(this.creatioService + '/loadIdCreatio/'+this.idAutocheck,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenCreatio"),
              "Content-Type": "application/json",
            },
          })
        .then(response =>{
          //console.log('Respuesta -->',response);

          if (response.data.length === 0) {
            setTimeout(() => {
              this.$router.push({ path: "/Oferta" });
            }, 150);

          } else {
            sessionStorage.setItem("IdCreatio", response.data[0].idcreatio);
            sessionStorage.setItem("nombre", response.data[0].nombre);
            sessionStorage.setItem("apellidos", response.data[0].apellidos);
            this.nombre = sessionStorage.getItem("nombre");
            this.apellidos = sessionStorage.getItem("apellidos");

            setTimeout(() => {
              this.$router.push({ path: "/Oferta" });
            }, 150);
          }


        }).catch(error=>{
          // this.mensajeError = 'ECCID';
          // this.modalErrorConexion = true;
          this.snifferError(error.message,'Creatio');
          console.log('Existe un error en Creatio ...', error.message);
        });
      },*/

      /*consultaCreatioReagendamiento(){

        console.log('Consulta Creatio Reagendamiento');

        this.idAutocheck = sessionStorage.getItem("idvaloration");

        axios.get(this.creatioService + '/loadIdCreatio/'+this.idAutocheck,
          {
            headers: {
              Authorization:
                "Bearer " + sessionStorage.getItem("tokenCreatio"),
              "Content-Type": "application/json",
            },
          })
          .then(response =>{
            //console.log('Respuesta -->',response.data.length);
            if (response.data.length === 0) {
              setTimeout(() => {
                this.$router.push({ path: "/Reagendamiento?vafolio=" + this.idAutocheck });
              }, 150);

            } else {
              sessionStorage.setItem("IdCreatio", response.data[0].idcreatio);
              sessionStorage.setItem("nombre", response.data[0].nombre);
              sessionStorage.setItem("apellidos", response.data[0].apellidos);
              this.nombre = sessionStorage.getItem("nombre");
              this.apellidos = sessionStorage.getItem("apellidos");

              setTimeout(() => {
                this.$router.push({ path: "/Reagendamiento?vafolio=" + this.idAutocheck });
              }, 150);
            }


          }).catch(error=>{
            // this.mensajeError = 'ECCID2';
            // this.modalErrorConexion = true;
              this.snifferError(error.message,'Creatio');
              console.log('Existe un error en Creatio ...',error.message);
          });
        },*/

      validaInfoFolio() {

        let body = { folio: this.folioVa,
              telefono: this.telefono
              };

        axios.post(
          this.serverAutoCheck + "/calendario/valoracion_agendamiento",
            body,
            {
              headers: {
                Authorization:
                  "Bearer " + sessionStorage.getItem("tokenIntelimotor"),
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {

            this.agendamiento = response.data.data[0].tiene_agendamiento;
            //console.log('Respuesta -->', response.data );

            if (this.agendamiento === 0) {

              sessionStorage.setItem("idcliente", response.data.data[0].id_cliente);
              sessionStorage.setItem("email", response.data.data[0].email);
              sessionStorage.setItem("telefono", response.data.data[0].telefono);
              sessionStorage.setItem("folio", response.data.data[0].folioVA);
              sessionStorage.setItem("idvaloration", response.data.data[0].folio);
              sessionStorage.setItem("oferta",response.data.data[0].oferta);
              sessionStorage.setItem("offer_day", response.data.data[0].oferta_hoy);
              sessionStorage.setItem("offer_consignment", response.data.data[0].oferta_consignacion);
              sessionStorage.setItem("fecha_validez", response.data.data[0].vigencia_oferta.substring(0,10));
              sessionStorage.setItem("marca", response.data.data[0].marca);
              sessionStorage.setItem("modelo", response.data.data[0].modelo);
              sessionStorage.setItem("anio", response.data.data[0].year);
              sessionStorage.setItem("version", response.data.data[0].trim);
              sessionStorage.setItem("color", response.data.data[0].ext_color);
              sessionStorage.setItem("kilometraje", response.data.data[0].kilometers);
              sessionStorage.setItem("nombre", response.data.data[0].cliente);
              // sessionStorage.setItem("apellidos", response.data[0].apellidos);

              //this.consultaCreatio();
              this.$router.push({ path: "/Oferta" });

            } else {

              sessionStorage.setItem("idvaloration", response.data.data[0].folio);
              //this.consultaCreatioReagendamiento();
              this.$router.push({ path: "/Reagendamiento?vafolio=" + response.data.data[0].folio });

            }
          })
          .catch((error) => {
            this.errormessage = 'Algo ha salido mal, Inténtelo de nuevo más tarde o llámanos al 800-711-286 o manda un mensaje de Wahstapp al 443 491 1681';
            this.errorvaloracion = true;
            this.mensajeError = 'EVAVF2';
            this.modalErrorConexion = true;
              this.snifferError(error.message,'Valoraciones');
              console.log('Existe un error en Valoraciones ...',error.message);
          });

      },

      cerrarModal(){

        this.modalModificar = false;
        this.modalnoValido = false;
        this.modalnoEncontrado = false;
        this.modalenSeguimiento = false;
        this.modalErrorConexion = false;
        this.folioVa = '';
        this.telefono = '';

      },

      formatPrice() {
        this.cpf(this.precio);
      },

      cpf(v){

        v=v.replace(/([^0-9\.]+)/g,'');
        v=v.replace(/^[\.]/,'');
        v=v.replace(/[\.][\.]/g,'');
        v=v.replace(/\.(\d)(\d)(\d)/g,'.$1$2');
        v=v.replace(/\.(\d{1,2})\./g,'.$1');
        v = v.toString().split('').reverse().join('').replace(/(\d{3})/g,'$1,');
        v = v.split('').reverse().join('').replace(/^[\,]/,'');
        return this.precio = "$ "+v;
        //return this.precio = v;
      },

      formatKms() {
        this.fkms(this.mileage);
      },

      fkms(v){

        v=v.replace(/([^0-9\.]+)/g,'');
        v=v.replace(/^[\.]/,'');
        v=v.replace(/[\.][\.]/g,'');
        v=v.replace(/\.(\d)(\d)(\d)/g,'.$1$2');
        v=v.replace(/\.(\d{1,2})\./g,'.$1');
        v = v.toString().split('').reverse().join('').replace(/(\d{3})/g,'$1,');
        v = v.split('').reverse().join('').replace(/^[\,]/,'');
        return this.mileage = v;
      },
       checkForm() {
        if (this.marcaSelect !== '' && this.modeloSelect !== '' && this.aniosSelect !== '' && this.versionSelect !== '' && this.colorSelect !== '' && this.mileage !== '') {
          this.formBool = true;
        } else {
          this.formBool = false;
        }
      },

      documentacion() {
        sessionStorage.setItem("prev", "vehículo")
        setTimeout(() => {
          // window.open('/Documentos');
          this.$router.push({ path: "/Documentos" });
        }, 150);
      },

    snifferError(error, servicio) {

      let data = {
        error: error,
        servicio: servicio,
      }


      axios.post(this.serverComunicaciones + "/snifferVa", data,
        {
          headers: {
            Authorization:
              "Bearer " + sessionStorage.getItem("tokenComunicacion"),
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => {
          console.log('Alerta enviada');
        })
        .catch((error) => {
          console.log('Error de alerta --->', error);
        });

    },

    },

    watch: {
      marcaSelect() {
        this.checkForm();
      },
      modeloSelect() {
        this.checkForm();
      },
      aniosSelect() {
        this.checkForm();
      },
      versionSelect() {
        this.checkForm();
      },
      colorSelect() {
        this.checkForm();
      },
      mileage() {
        this.checkForm();
      }
    },

    created() {
      //console.log('URL Actual --->',window.location.href);
      this.cargarToken();
      this.tokenComunicaciones();
      //this.allBrands();
      window.scrollTo(0,0);
    },
    onMounted(){
      window.scrollTo(0, 0)
    }
  };
</script>
<style>
  .moneyInput {
  position: absolute;
  left: 15.5px;
  top: .5px;
  border: 4px solid #D9D9D9;
  background: #D9D9D9;
  height: 44px;
  width: 30px;
  border-radius: 0px 0px 0px 0px;
  font-family: 'Montserrat';
  font-style: normal;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  align-items: center;
  color: black;
  }
  .moneyText {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  }



</style>